import { render, staticRenderFns } from "./ikidsmodalphoto.vue?vue&type=template&id=a84dc552&"
import script from "./ikidsmodalphoto.vue?vue&type=script&lang=js&"
export * from "./ikidsmodalphoto.vue?vue&type=script&lang=js&"
import style0 from "./ikidsmodalphoto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports